import type { StandardApiResponse, StandardPagedData } from '@dlap-ui/core';

/** Support endpoints return both legacy pages/arrays and enveloped responses. */
export function normalizeTicketPage<T>(
  response: unknown,
): StandardApiResponse<StandardPagedData<T>> {
  const envelope = (response ?? {}) as Record<string, unknown>;
  if (envelope['success'] === false) {
    throw new Error(
      String(envelope['message'] || 'The ticket request failed.'),
    );
  }
  const payload = envelope['data'] ?? response;
  const page = (payload ?? {}) as Record<string, unknown>;
  const content = (
    Array.isArray(payload)
      ? payload
      : Array.isArray(page['content'])
        ? page['content']
        : []
  ) as T[];
  return {
    success: true,
    status: String(envelope['status'] ?? 'OK'),
    code: Number(envelope['code'] ?? 200),
    message: String(envelope['message'] ?? ''),
    data: {
      content,
      totalElements: Number(page['totalElements'] ?? content.length),
    },
  };
}

export function requireTicketSuccess<T>(response: T): T {
  if ((response as { success?: boolean } | null)?.success === false) {
    throw new Error(
      String(
        (response as { message?: string }).message ||
          'The ticket request failed.',
      ),
    );
  }
  return response;
}
